//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UiCloseButton from './UiCloseButton.vue';
import UiIcon from './UiIcon.vue';

export default {
  name: 'UiAlert',

  components: {
    UiCloseButton,
    UiIcon,
  },

  props: {
    type: {
      type: String,
      default: 'info', // 'info', 'success', 'warning', or 'error'
    },
    removeIcon: {
      type: Boolean,
      default: false,
    },
    disableAnimation: {
      type: Boolean,
      default: false,
    },
    dismissible: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    classes() {
      return [`ui-alert--type-${this.type}`, { 'has-no-transition': this.disableAnimation }];
    },
  },

  methods: {
    dismissAlert() {
      this.$emit('dismiss');
    },
  },
};

